import {Route} from 'react-router-dom';
import getElement from 'config/navigation/util/get-element';
import getRoute from './get-route';
import {NavigationProps} from '..';
import getSubRoute from './get-sub-route';

const useNavigation = (navigation: NavigationProps[]) => {
  const renderNavigation = ({
    path,
    element,
    routes,
    subRoutes,
  }: NavigationProps) => (
    <Route
      key={path}
      element={
        element &&
        getElement({
          element,
          permissions: routes?.map(({permission, exactPermission}) =>
            exactPermission ? {name: permission, exactPermission} : permission,
          ),
        })
      }
      {...{path}}>
      {routes && routes.map(getRoute)}
      {subRoutes && subRoutes.map(getSubRoute)}
    </Route>
  );

  return navigation.map(renderNavigation);
};

export default useNavigation;
